(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('LeadDiscountDialogController', LeadDiscountDialogController);

    LeadDiscountDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LeadDiscount', 'DiscountReason', 'DiscountRate'];

    function LeadDiscountDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LeadDiscount, DiscountReason, DiscountRate) {
        var vm = this;
        vm.leadDiscount = entity;
        vm.discountreasons = DiscountReason.query();
        vm.discountrates = DiscountRate.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:leadDiscountUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.leadDiscount.id !== null) {
                LeadDiscount.update(vm.leadDiscount, onSaveSuccess, onSaveError);
            } else {
                LeadDiscount.save(vm.leadDiscount, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
